import {Timestamped} from 'common/src/modules/movie/movieRendering';
import {MovieLayer} from 'common/src/modules/movie/movieLayers.types';
import {MovieLayerType} from 'common/src/modules/movie/movie.enums';
import getTextBox from './getTextBox';
import getShapeBoundingBox from './getShapeBoundingBox';
import {MovieComp} from 'common/src/modules/movie/movie.types';
import {Box} from '../../movieEditor/movieEditor.types';

function getLayerBoundingBox(
  timedLayer: Timestamped<MovieLayer>,
  comps: Record<string, MovieComp>,
): Box {
  if (!timedLayer) return null;

  switch (timedLayer.ty) {
    case MovieLayerType.Image:
      return {
        x: timedLayer.image.x,
        y: timedLayer.image.y,
        w: timedLayer.image.w,
        h: timedLayer.image.h,
      };
    case MovieLayerType.Video:
      return {
        x: timedLayer.video.x,
        y: timedLayer.video.y,
        w: timedLayer.video.w,
        h: timedLayer.video.h,
      };
    case MovieLayerType.Text:
      return getTextBox(timedLayer);
    case MovieLayerType.Null:
      return {x: -10, y: -10, w: 20, h: 20};
    case MovieLayerType.PreComp:
      const comp = comps[timedLayer.precomp.compId];

      return {x: 0, y: 0, w: comp.w, h: comp.h};
    case MovieLayerType.Shape:
      const {left, right, top, bottom} = timedLayer.shape.shapes.reduce(
        (edges, shape) => {
          const {x, y, w, h} = getShapeBoundingBox(shape);

          return {
            left: Math.min(edges.left, x),
            top: Math.min(edges.top, y),
            right: Math.max(edges.right, x + w),
            bottom: Math.max(edges.bottom, y + h),
          };
        },
        {left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity},
      );

      return {
        x: left,
        y: top,
        w: right - left,
        h: bottom - top,
      };
  }
}

export {getLayerBoundingBox};
